"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _throttle = _interopRequireDefault(require("lodash/throttle"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _environment = _interopRequireDefault(require("@spothero/utils/environment"));

var _AutoSuggestInput = _interopRequireDefault(require("../AutoSuggestInput/AutoSuggestInput"));

var _TextInputPropTypes = _interopRequireDefault(require("../TextInput/TextInputPropTypes"));

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

(function () {
  var enterModule = require('react-hot-loader').enterModule;

  enterModule && enterModule(module);
})();

var GooglePlacesSearchInput =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(GooglePlacesSearchInput, _Component);

  function GooglePlacesSearchInput(props) {
    var _this;

    (0, _classCallCheck2.default)(this, GooglePlacesSearchInput);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(GooglePlacesSearchInput).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "state", {
      suggestions: []
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_onChange", function (evt) {
      var onChange = _this.props.onChange;
      var value = evt.target.value;

      if (!value || value.length < 3) {
        _this.setState({
          suggestions: []
        });
      } else {
        _this._suggestionFetch(value);
      }

      if (onChange) {
        onChange(evt);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_onSuggestionSelect", function (suggestion) {
      var onSuggestionSelect = _this.props.onSuggestionSelect;
      var placeId = suggestion.place_id,
          description = suggestion.description;

      if (suggestion.location) {
        onSuggestionSelect(suggestion);
      } else {
        _this._geocoder.geocode(placeId ? {
          placeId: placeId
        } : {
          address: description
        }, function (results, status) {
          if (status !== _this._gmaps.GeocoderStatus.OK) {
            return;
          }

          var gmaps = results[0];
          var geoCodedLocation = gmaps.geometry.location;
          suggestion.label = description;
          suggestion.gmaps = gmaps;
          suggestion.location = {
            lat: geoCodedLocation.lat(),
            lng: geoCodedLocation.lng()
          };
          onSuggestionSelect(suggestion);
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_searchSuggestions", function (value) {
      var _this$props = _this.props,
          country = _this$props.country,
          types = _this$props.types,
          bounds = _this$props.bounds;
      var options = {
        input: value
      };

      if (types) {
        options.types = types;
      }

      if (bounds) {
        options.bounds = bounds;
      } else {
        var circle = new _this._gmaps.Circle({
          center: {
            lat: 0,
            lng: 0
          },
          radius: 10000
        });
        options.bounds = circle.getBounds();
      }

      if (country) {
        options.componentRestrictions = {
          country: country
        };
      }

      _this._autocompleteService.getPlacePredictions(options, function (suggestions) {
        if (suggestions) {
          suggestions.map(function (suggestion) {
            suggestion.label = suggestion.description;
            return suggestion;
          });
        }

        _this.setState({
          suggestions: suggestions
        });
      });
    });
    var googleMaps = props.googleMaps;

    var isBrowser = _environment.default.isBrowser();

    _this._suggestionFetch = (0, _throttle.default)(_this._searchSuggestions, 500);
    _this._gmaps = googleMaps;
    _this._autocompleteService = isBrowser ? new _this._gmaps.places.AutocompleteService() : null;
    _this._geocoder = isBrowser ? new _this._gmaps.Geocoder() : null;
    return _this;
  }

  (0, _createClass2.default)(GooglePlacesSearchInput, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          className = _this$props2.className,
          poweredByGoogleFooter = _this$props2.poweredByGoogleFooter,
          types = _this$props2.types,
          country = _this$props2.country,
          onClear = _this$props2.onClear,
          textInputProps = (0, _objectWithoutProperties2.default)(_this$props2, ["className", "poweredByGoogleFooter", "types", "country", "onClear"]);
      var suggestions = this.state.suggestions;
      var classes = (0, _classnames.default)('GooglePlacesSearchInput', className);
      return _react.default.createElement("div", {
        className: classes
      }, _react.default.createElement(_AutoSuggestInput.default, (0, _extends2.default)({
        ref: function ref(node) {
          _this2._autosuggest = node;
        }
      }, textInputProps, {
        onChange: this._onChange,
        suggestions: suggestions,
        types: types,
        country: country,
        suggestionBoxFooter: poweredByGoogleFooter,
        onClear: onClear,
        onSuggestionSelect: this._onSuggestionSelect,
        autoActivateFirstSuggest: true
      })));
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }, {
    key: "node",

    /**
     * Getter for the input DOM element.
     *
     * @public
     * @returns {Element} - The input element.
     */
    get: function get() {
      return this._autosuggest.node;
    }
  }]);
  return GooglePlacesSearchInput;
}(_react.Component);

exports.default = GooglePlacesSearchInput;
(0, _defineProperty2.default)(GooglePlacesSearchInput, "propTypes", (0, _objectSpread2.default)({}, _TextInputPropTypes.default, {
  /** Function to execute when a suggestion is selected. */
  onSuggestionSelect: _propTypes.default.func.isRequired,

  /** Optional function to execute when input field is cleared. */
  onClear: _propTypes.default.func,

  /** Used to limit the suggestion results by country. */
  country: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.string)]),

  /** Used to limit the suggestion results by certain google place types. */
  types: _propTypes.default.array,

  /** Used to limit the suggestion results by lat/long bounds. */
  bounds: _propTypes.default.object,

  /** The `google maps` object for using the autocomplete service. */
  googleMaps: _propTypes.default.object,

  /** A custom element (typically a PoweredByGoogle component) to display at the bottom of the suggestion list. */
  poweredByGoogleFooter: _propTypes.default.element.isRequired
}));
(0, _defineProperty2.default)(GooglePlacesSearchInput, "defaultProps", {
  placeholder: 'Search Address or Venue',
  country: 'us',
  icon: _react.default.createElement(_Icon.default, {
    name: "search"
  })
});
;

(function () {
  var reactHotLoader = require('react-hot-loader').default;

  var leaveModule = require('react-hot-loader').leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(GooglePlacesSearchInput, "GooglePlacesSearchInput", "/Users/mprzybylski/Work/SpotHero/fe-ui/src/GooglePlacesSearchInput/GooglePlacesSearchInput.jsx");
  leaveModule(module);
})();

;